import { render, staticRenderFns } from "./GVisListItem.vue?vue&type=template&id=840c006c&scoped=true&"
import script from "./GVisListItem.vue?vue&type=script&lang=ts&"
export * from "./GVisListItem.vue?vue&type=script&lang=ts&"
import style0 from "./GVisListItem.vue?vue&type=style&index=0&id=840c006c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840c006c",
  null
  
)

export default component.exports